const toBuildTimeCTToken = () => {
  const { APP_CONFIG_PRESET = 'prod' } = process.env;

  return process.env[`CT_BUILD_TIME_TOKEN_${APP_CONFIG_PRESET.toUpperCase()}`];
};

export default toBuildTimeCTToken;
